import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;


function storeToken(token) {
    localStorage.setItem("token", token);
}

const LoginHandler = {

    async doHandelLogin(payload) {
        try {
            const { data } = await axios.post(`${BASE_URL}auth/login`, payload);

            storeToken(data.data.token)

            return data;
        } catch (error) {
            return error;
        }
    },
}

export default LoginHandler